import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Invite } from '@models/businesses';
import { Repo } from '@repos/repo.service';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { CollectionPaths } from '@models/collections';
import { UserProfileState } from '@state/user-profile';

@Injectable({
	providedIn: 'root',
})
export class BusinessInviteService extends Repo<Invite, string> {
	@SelectSnapshot(UserProfileState.getCurrentBusinessId) businessId: string;

	GetCollectionPath(businessId?: string): string {
		return CollectionPaths.business_invites(businessId ?? this.businessId);
	}

	constructor(private firestore: AngularFirestore) {
		super(firestore);
	}
}
